import {Group} from "three";
import * as THREE from "three";
import {max, min} from "three/nodes";

export default class DtLights extends Group {
    constructor(x, y, z) {
        super();

        const slider = document.getElementById("lightSlider3d");

        const lightInitIntensity = .8;
        const spotLight = new THREE.SpotLight('#FDFDFD', this.calculateLightIntensity(lightInitIntensity, slider.value, null, .8));
        spotLight.position.set(x/2, y*2, z);
        spotLight.distance = 3000;
        spotLight.target.position.set(x/2, 0, z/2);
        spotLight.castShadow = true;
        spotLight.shadow.mapSize.width = 8192;
        spotLight.shadow.mapSize.height = 8192;
        this.add(spotLight);
        this.add(spotLight.target);

        // const spotLightHelper = new THREE.SpotLightHelper(spotLight);
        // this.add(spotLightHelper);

        let pointLights = [];
        const pointLightInitIntensity = .3;
        let pointLightPositions = [x/2, -x, x*2];
        pointLightPositions.forEach((position) => {
            const pointLight = new THREE.PointLight("#FDFDFD", this.calculateLightIntensity(pointLightInitIntensity, slider.value, null, .3));
            pointLight.position.set(position, y*1.5, z/2 );
            this.add(pointLight);
            pointLights.push(pointLight);

            // const pointLightHelper = new THREE.PointLightHelper(pointLight, 10);
            // this.add(pointLightHelper);
        });

        const directionalLightInitIntensity = .5;
        const directionalLight = new THREE.DirectionalLight("#FDFDFD", this.calculateLightIntensity(directionalLightInitIntensity, slider.value, .2, .7));
        directionalLight.lookAt(x, y, z);
        directionalLight.position.set(0, y * 3, z * 4);
        this.add(directionalLight);

        // const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight);
        // this.add(directionalLightHelper);

        slider.oninput = () => {
            spotLight.intensity = this.calculateLightIntensity(lightInitIntensity, slider.value, null, .8);

            pointLights.forEach((pointLight) => {
                pointLight.intensity = this.calculateLightIntensity(pointLightInitIntensity, slider.value, null, .3);
            });

            directionalLight.intensity = this.calculateLightIntensity(directionalLightInitIntensity, slider.value, .2, .7);
        };
    }

    calculateLightIntensity(initIntensity, divider, minValue = null, maxValue = null) {
        if(divider == 0) {
            return initIntensity;
        }

        let intensity = initIntensity / (10 / divider);

        if(minValue && intensity < minValue) {
            return minValue;
        } else if (maxValue && intensity > maxValue) {
            return maxValue;
        }

        return intensity;
    }
}